<div class="settings-container data-detail-view-builder-settings-container">
  <div class="settings-header">
    <div class="data-detail-view-builder-header">
      <h6>Settings</h6>
      <rappider-button text="Edit Detail View JSON Data"
                       [icon]="{name: 'fa-solid fa-brackets-curly'}"
                       (click)="onEditJsonData()">
      </rappider-button>
    </div>
    <hr>
  </div>

  <div class="settings-content">
    <div class="settings-form-content">
      <div class="form-control-area">
        <div class="label">
          <span><b>Preview Column Number:</b></span>
        </div>
        <rappider-select *ngIf="value"
                         [ngModel]="previewColumnNumber"
                         [options]="columnNumberOptions"
                         [optionMode]="OptionMode.Options"
                         [settings]="selectSettings"
                         (ngModelChange)="onPreviewColumnNumberChange($event)"
                         placeholder="Select column number"></rappider-select>
        <small class="help-text">Select the number of columns to display in the preview</small>
      </div>

      <div class="form-control-area">
        <div class="label">
          <span><b>Show In Collapsed Sections:</b></span>
        </div>
        <rappider-switch *ngIf="value"
                         [ngModel]="value?.showInCollapsedSections"
                         (ngModelChange)="onShowInCollapsedSectionsChange($event)"></rappider-switch>
        <small class="help-text">Display form sections in collapsible panels</small>
      </div>

      <div class="form-control-area" *ngIf="value && value.showInCollapsedSections">
        <div class="label">
          <span><b>Default Section Title:</b></span>
        </div>
        <rappider-textbox [ngModel]="getDefaultSectionTitle()"
                          (ngModelChange)="onDefaultSectionTitleChange($event)"
                          placeholder="Enter section title"></rappider-textbox>
        <small class="help-text">Set the title for collapsed sections. Leave empty to use default section names</small>
      </div>

      <!-- Field Styles Section -->
      <div class="form-control-area field-formatting-area" *ngIf="value && availableFields.length > 0">
        <div class="label">
          <span><b>Field Styles:</b></span>
        </div>
        <div class="fields-list-container">
          <!-- All Fields Row -->
          <rappider-field-formatting-toolbar
            [field]="null"
            [label]="'All Fields'"
            [context]="FieldFormattingContext.ALL_FIELDS"
            [isAllFields]="true"
            [isValueContext]="false"
            [currentTextColor]="getAllFieldsColor()"
            [currentBackgroundColor]="getAllFieldsBackgroundColor()"
            [currentStyle]="getAllFieldsStyle()"
            [textColorOptions]="textColorOptions"
            [styleButtons]="styleButtons"
            [isTextColorActive]="hasAllFieldsSameColor() && getAllFieldsColor() && getAllFieldsColor() !== TextColorType.Default"
            [isBackgroundColorActive]="hasAllFieldsSameBackgroundColor() && getAllFieldsBackgroundColor() && getAllFieldsBackgroundColor() !== TextColorType.Default"
            [textColorValue]="getTextColorValue(getAllFieldsColor())"
            [backgroundColorValue]="getTextColorValue(getAllFieldsBackgroundColor())"
            (textColorChange)="onFormattingColorChange($event)"
            (backgroundColorChange)="onFormattingBackgroundColorChange($event)"
            (styleToggle)="setCurrentFieldContext($event.context); onFormattingStyleToggle($event.styleType)"
            (contextSet)="setCurrentFieldContext($event)">
          </rappider-field-formatting-toolbar>

          <!-- Individual Field Rows -->
          <rappider-field-formatting-toolbar
            *ngFor="let field of availableFields; trackBy: trackByFieldName"
            [field]="field"
            [context]="field.fieldName"
            [isAllFields]="false"
            [isValueContext]="false"
            [currentTextColor]="getFieldTextColor(field.fieldName)"
            [currentBackgroundColor]="getFieldBackgroundColor(field.fieldName)"
            [currentStyle]="getFieldTextStyle(field.fieldName)"
            [textColorOptions]="textColorOptions"
            [styleButtons]="styleButtons"
            [isTextColorActive]="getFieldTextColor(field.fieldName) && getFieldTextColor(field.fieldName) !== TextColorType.Default"
            [isBackgroundColorActive]="getFieldBackgroundColor(field.fieldName) && getFieldBackgroundColor(field.fieldName) !== TextColorType.Default"
            [textColorValue]="getTextColorValue(getFieldTextColor(field.fieldName))"
            [backgroundColorValue]="getTextColorValue(getFieldBackgroundColor(field.fieldName))"
            (textColorChange)="onFormattingColorChange($event)"
            (backgroundColorChange)="onFormattingBackgroundColorChange($event)"
            (styleToggle)="setCurrentFieldContext($event.context); onFormattingStyleToggle($event.styleType)"
            (contextSet)="setCurrentFieldContext($event)">
          </rappider-field-formatting-toolbar>
        </div>
        <small class="help-text">Set the available color options and apply formatting controls (Bold, Italic, Underline) to style field labels.</small>
      </div>

      <!-- Value Styles Section -->
      <div class="form-control-area field-formatting-area" *ngIf="value && availableFields.length > 0">
        <div class="label">
          <span><b>Value Styles:</b></span>
        </div>
        <div class="fields-list-container">
          <!-- All Values Row -->
          <rappider-field-formatting-toolbar
            [field]="null"
            [label]="'All Values'"
            [context]="FieldFormattingContext.ALL_VALUES"
            [isAllFields]="true"
            [isValueContext]="true"
            [currentTextColor]="getAllFieldsValueColor()"
            [currentBackgroundColor]="getAllFieldsValueBackgroundColor()"
            [currentStyle]="getAllFieldsValueStyle()"
            [textColorOptions]="textColorOptions"
            [styleButtons]="styleButtons"
            [isTextColorActive]="hasAllFieldsSameValueColor() && getAllFieldsValueColor() && getAllFieldsValueColor() !== TextColorType.Default"
            [isBackgroundColorActive]="hasAllFieldsSameValueBackgroundColor() && getAllFieldsValueBackgroundColor() && getAllFieldsValueBackgroundColor() !== TextColorType.Default"
            [textColorValue]="getTextColorValue(getAllFieldsValueColor())"
            [backgroundColorValue]="getTextColorValue(getAllFieldsValueBackgroundColor())"
            (textColorChange)="onFormattingColorChange($event)"
            (backgroundColorChange)="onFormattingBackgroundColorChange($event)"
            (styleToggle)="setCurrentFieldContext($event.context); onFormattingStyleToggle($event.styleType)"
            (contextSet)="setCurrentFieldContext($event)">
          </rappider-field-formatting-toolbar>

          <!-- Individual Field Value Rows -->
          <rappider-field-formatting-toolbar
            *ngFor="let field of availableFields; trackBy: trackByFieldName"
            [field]="field"
            [context]="createValueContext(field.fieldName)"
            [isAllFields]="false"
            [isValueContext]="true"
            [currentTextColor]="getFieldValueTextColor(field.fieldName)"
            [currentBackgroundColor]="getFieldValueBackgroundColor(field.fieldName)"
            [currentStyle]="getFieldValueTextStyle(field.fieldName)"
            [textColorOptions]="textColorOptions"
            [styleButtons]="styleButtons"
            [isTextColorActive]="getFieldValueTextColor(field.fieldName) && getFieldValueTextColor(field.fieldName) !== TextColorType.Default"
            [isBackgroundColorActive]="getFieldValueBackgroundColor(field.fieldName) && getFieldValueBackgroundColor(field.fieldName) !== TextColorType.Default"
            [textColorValue]="getTextColorValue(getFieldValueTextColor(field.fieldName))"
            [backgroundColorValue]="getTextColorValue(getFieldValueBackgroundColor(field.fieldName))"
            (textColorChange)="onFormattingColorChange($event)"
            (backgroundColorChange)="onFormattingBackgroundColorChange($event)"
            (styleToggle)="setCurrentFieldContext($event.context); onFormattingStyleToggle($event.styleType)"
            (contextSet)="setCurrentFieldContext($event)">
          </rappider-field-formatting-toolbar>
        </div>
        <small class="help-text">Set the available color options and apply formatting controls (Bold, Italic, Underline) to style field values.</small>
      </div>
    </div>
  </div>
</div>
